import React from 'react'

export default (props) => (
    <svg width="16" height="16" viewBox="0 0 18 18" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Icons" stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(-3.000000, -3.000000)">
            <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
            <path d="M3,17.46 L3,20.5 C3,20.78 3.22,21 3.5,21 L6.54,21 C6.67,21 6.8,20.95 6.89,20.85 L17.81,9.94 L14.06,6.19 L3.15,17.1 C3.05,17.2 3,17.32 3,17.46 Z M20.71,7.04 C21.1,6.65 21.1,6.02 20.71,5.63 L18.37,3.29 C17.98,2.9 17.35,2.9 16.96,3.29 L15.13,5.12 L18.88,8.87 L20.71,7.04 Z" fill="#9FA2B4"></path>
        </g>
    </svg>
)